import { render } from "./500-error.vue?vue&type=template&id=4fddb3d9&scoped=true"
import script from "./500-error.vue?vue&type=script&lang=js"
export * from "./500-error.vue?vue&type=script&lang=js"

import "./500-error.vue?vue&type=style&index=0&id=4fddb3d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fddb3d9"]])

export default __exports__